// Note: Addresses are on the Mumbai Testnet

export const CLEARING_HOUSE_ADDRESS =
  "0xE412EF5379F78f2070d46996fF1be869438AD4d3";

export const BTC_BASE_TOKEN_ADDRESS =
  "0x6140Fca43218eb7A02C51C032F2399457D020026";

export const QUOTE_TOKEN_ADDRESS = "0x62F7F2324433Eb82f8e06fc5BD02eA0D1FCB1e66";

export const ORDER_BOOK_ADDRESS = "0x588e88f4CE9F47D76F1279472e4C92CdDACfC06F";

export const VAULT_ADDRESS = "0xA539cd0690ceBDf1598821bd91A89e0672a161CD";

export const XUSD_ADDRESS = "0xA3C957f5119eF3304c69dBB61d878798B3F239D9";
